import React from "react";
import { Link } from 'react-router-dom';

import './navbar.styles.scss';

class NavBar extends React.Component {
  constructor(props) {
    super(props);

    this.listener = null;
    this.state = {
      scrollStatus: "navbar-header"
    };
  }

  componentDidMount() {
    this.listener = document.addEventListener("scroll", () => {
      var scrolled = document.scrollingElement.scrollTop;
      if (scrolled > this.props.height - 60) {
        if (this.state.scrollStatus !== "navbar-section") {
          this.setState({ scrollStatus: "navbar-section" });
        }
      } else {
        if (this.state.scrollStatus !== "navbar-header") {
          this.setState({ scrollStatus: "navbar-header" });
        }
      }
    });
  }

  componentDidUpdate() {
    document.removeEventListener("scroll", this.listener);
  }

  render() {
    const { scrollStatus } = this.state;

    return (
      <div className={scrollStatus}>
        <Link to='/' className='navbar-link'>Home</Link>
        <Link to='/projects' className='navbar-link'>Projects</Link>
        <Link to='/experiences' className='navbar-link'>Experiences</Link>
        <Link to='/courses' className='navbar-link'>Courses</Link>
      </div>
    )
  }
}

export default NavBar;
